import fetch from 'isomorphic-fetch';
import config from '../../config';

export const sendLeadGenEmail = async (values) => {
    // TESTING EMAIL TO TRIGGER FAILURE SCENARIO(S)
    const testFailEmail =
        values.emailAddress.toLowerCase() === 'fail@example.com';
    const emailEndpoint = testFailEmail
        ? `leadgen/testfail`
        : `leadgen/subscribe`;

    const response = await fetch(
        `${config('apiDomain', 'https://apidev.awstrp.net')}/${emailEndpoint}`,
        {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-TRP-Requested-With': 'XMLHttpRequest',
                apikey: config('apiKey')
            },
            body: JSON.stringify(values)
        }
    ).catch((error) => error && false);

    return testFailEmail || !response
        ? false
        : response.json().then((body) => body.status === 'success');
};



// WEBPACK FOOTER //
// ./src/components/LeadGenForm/util.js